export const triggerAttributeName = "data-trigger-guided-tour";
export const localStorageNameAutostart = "ux.guided-tour.autostart";
export const localStorageNameCompleted = "ux.guided-tour.completed";
//# sourceMappingURL=constants.js.map
